import React from "react";

function ErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g transform="translate(-10019 -8263)">
        <path fill="none" d="M10019 8263h48v48h-48z"/>
        <circle
          cx="24"
          cy="24"
          r="24"
          fill="#fd5759"
          transform="translate(10019 8263)"
        />
        <g fill="#fff" transform="translate(9748 8111)">
          <circle cx="3" cy="3" r="3" transform="translate(292 184)"/>
          <path d="M295 182a2.25 2.25 0 002.25-2.25L298 165a3 3 0 00-6 0l.75 14.75A2.25 2.25 0 00295 182z"/>
        </g>
      </g>
    </svg>
  );
}

export default ErrorIcon;
